import { C_LOC_COOKIE, C_LOC_COOKIE_EXPIRES_DAYS, C_2LOC_COOKIE, C_2LOC_COOKIE_EXPIRES_DAYS } from "../../../../constants/cookies.js";
import Cookie from "js-cookie";
const getDeliveryLocationSelectorDataProps = (moduleSettings) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const keyValueMap = ((_a = moduleSettings.key_value) == null ? void 0 : _a.reduce(
    (composableWindowMap, keyValueObj) => {
      composableWindowMap[keyValueObj["key"]] = keyValueObj["value"];
      return composableWindowMap;
    },
    {}
  )) || {};
  return {
    defaultLocation: (_b = moduleSettings.properties[0]) == null ? void 0 : _b.defaultLocation,
    defaultState: (_c = moduleSettings.properties[0]) == null ? void 0 : _c.defaultState,
    reloadPageOnAutomaticLocationUpdate: (_d = moduleSettings.properties[0]) == null ? void 0 : _d.reloadPageOnAutomaticLocationUpdate,
    reloadPageOnManualLocationUpdate: (_e = moduleSettings.properties[0]) == null ? void 0 : _e.reloadPageOnManualLocationUpdate,
    iconName: (_g = (_f = moduleSettings.properties[0]) == null ? void 0 : _f.icons) == null ? void 0 : _g.deliveryLocationIcon,
    akamaiSnifferTooltip: (_i = (_h = moduleSettings.properties[0]) == null ? void 0 : _h.icons) == null ? void 0 : _i.akamaiSnifferTooltip,
    locale: moduleSettings.locale,
    locationAriaLabelPrefix: keyValueMap["locationarialabelprefix"],
    locationAriaLabelSuffix: keyValueMap["locationarialabelsuffix"],
    locationSelectorDefault: keyValueMap["locationselectordefault"],
    locationSelectorLabel: keyValueMap["locationselectorlabel"]
  };
};
const getCountryCodeFromLocale = (locale) => {
  return locale.split("-")[1].toUpperCase();
};
const setCLocCookie = (countryCode, state) => {
  if (countryCode && countryCode === "CA" && state) {
    const cLocCookieValue = `${countryCode}${state}`;
    Cookie.set(C_LOC_COOKIE, cLocCookieValue, {
      expires: C_LOC_COOKIE_EXPIRES_DAYS
    });
  }
};
const setC2LocCookie = (countryCode, eligibleRegions = [], region) => {
  if (!region || countryCode !== "CA") {
    return;
  }
  const isGroceryEligible = eligibleRegions.includes(region).toString();
  Cookie.set(C_2LOC_COOKIE, isGroceryEligible, {
    expires: C_2LOC_COOKIE_EXPIRES_DAYS
  });
};
export {
  getCountryCodeFromLocale,
  getDeliveryLocationSelectorDataProps,
  setC2LocCookie,
  setCLocCookie
};
